import React from "react";

import classnames from "classnames";
import isIntuit from "Intuit/isIntuit";

import BodyText from "Common/BodyText";
import Button from "Common/Button";
import { Div } from "Common/HTML";
import RemoveIcon from "Common/RemoveIcon";

import type { FieldProps } from "redux-form";

import makeBem from "Utils/makeBem";

const bem = makeBem("SIFormFileInput");
type FileBoxProps = {
  file: File;
  onRemove: () => void;
};
export const FileBox = ({ file, onRemove, ...rest }: FileBoxProps) => (
  <Div
    className={classnames(bem("FileBox"), "clearfix", {
      [bem("FileBox", "intuit")]: isIntuit(),
    })}
    {...rest}
  >
    <div className="float-right">
      <Button
        className={classnames({
          [bem("RemoveButton", "intuit")]: isIntuit(),
        })}
        px={2}
        color="link"
        onClick={onRemove}
      >
        <RemoveIcon />
      </Button>
    </div>
    <BodyText className={bem("FileName")}>{file.name}</BodyText>
  </Div>
);
// Redux form doesn't have a MetaProps =/
type MetaProps = FieldProps["meta"];
type FakeInputBoxProps = {
  buttonText: string;
  buttonColor: string;
  placeholderText: string;
  onAddClick: () => void;
  meta: MetaProps;
};
export const FakeInputBox = ({ buttonText, buttonColor, placeholderText, onAddClick, meta, ...rest }: FakeInputBoxProps) => (
  <Div
    className={classnames(bem("FakeInputBox"), "clearfix", {
      [bem("FakeInputBox", "intuit")]: isIntuit(),
      [bem(null, "error-intuit")]: isIntuit() && meta && meta.touched && meta.error !== undefined,
      [bem(null, "focused-intuit")]: isIntuit() && meta && meta.active,
    })}
    {...rest}
  >
    <div className="float-right">
      <Button className={bem("SelectButton")} color={buttonColor} onClick={onAddClick}>
        {buttonText}
      </Button>
    </div>
    <BodyText className={bem("FileName")} onClick={onAddClick}>
      {placeholderText}
    </BodyText>
  </Div>
);
